import * as React from "react"
import type { SVGProps } from "react"
const SvgFilterAdd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M17.02 2q.65 0 .91.55.27.56-.11 1.05l-5.8 7.4v6q0 .42-.29.71-.29.3-.71.29h-2a1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71v-6l-5.8-7.4a1 1 0 0 1-.11-1.05Q2.37 2 3.02 2zm-7 8.3L14.97 4h-9.9z"
      clipRule="evenodd"
    />
    <path d="M15 19h2v2q0 .42.29.71.29.3.71.29.42 0 .71-.29.3-.29.29-.71v-2h2q.42 0 .71-.29.3-.29.29-.71 0-.42-.29-.71A1 1 0 0 0 21 17h-2v-2q0-.42-.29-.71A1 1 0 0 0 18 14q-.42 0-.71.29-.3.29-.29.71v2h-2q-.42 0-.71.29-.3.29-.29.71 0 .42.29.71.29.3.71.29" />
  </svg>
)
export default SvgFilterAdd
